/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  ServiceType,
  InboundType,
  InboundInsuranceOnDateOfService,
  Benefit,
  NjmmisCheckStatus,
} from './globalTypes' // ====================================================
// GraphQL mutation operation: UncompleteInbound
// ====================================================

import {UncompleteInboundVariables as UncompleteInboundVariablesOrig} from '../types/UncompleteInbound'
import {UncompleteInbound as UncompleteInboundOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound as UncompleteInbound_uncompleteInboundOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_account as UncompleteInbound_uncompleteInbound_accountOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck as UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheckOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_personFormData as UncompleteInbound_uncompleteInbound_personFormDataOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_person as UncompleteInbound_uncompleteInbound_personOrig} from '../types/UncompleteInbound'
import {AdditionalData} from 'utils/getAdditionalData'
import {parseAdditionalData} from 'utils/getAdditionalData'
import {serializeAdditionalData} from 'utils/getAdditionalData'
import formatISO from 'date-fns/formatISO'
import {parseDate} from 'utils/form/fieldTypes'
import {formatISODate} from 'utils/date'
import {UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations as UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminationsOrig} from '../types/UncompleteInbound'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {UncompleteInbound_uncompleteInbound_person_openApplications as UncompleteInbound_uncompleteInbound_person_openApplicationsOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_completedBy as UncompleteInbound_uncompleteInbound_completedByOrig} from '../types/UncompleteInbound'
import {UncompleteInbound_uncompleteInbound_startedBy as UncompleteInbound_uncompleteInbound_startedByOrig} from '../types/UncompleteInbound'
export interface UncompleteInbound_uncompleteInbound_startedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUncompleteInbound_uncompleteInbound_startedBy = (
  serialized: UncompleteInbound_uncompleteInbound_startedByOrig
): UncompleteInbound_uncompleteInbound_startedBy => ({...serialized})
export const serializeUncompleteInbound_uncompleteInbound_startedBy = (
  deserialized: UncompleteInbound_uncompleteInbound_startedBy
): UncompleteInbound_uncompleteInbound_startedByOrig => ({...deserialized})
export interface UncompleteInbound_uncompleteInbound_completedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUncompleteInbound_uncompleteInbound_completedBy = (
  serialized: UncompleteInbound_uncompleteInbound_completedByOrig
): UncompleteInbound_uncompleteInbound_completedBy => ({...serialized})
export const serializeUncompleteInbound_uncompleteInbound_completedBy = (
  deserialized: UncompleteInbound_uncompleteInbound_completedBy
): UncompleteInbound_uncompleteInbound_completedByOrig => ({...deserialized})
export interface UncompleteInbound_uncompleteInbound_person_openApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUncompleteInbound_uncompleteInbound_person_openApplications = (
  serialized: UncompleteInbound_uncompleteInbound_person_openApplicationsOrig
): UncompleteInbound_uncompleteInbound_person_openApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUncompleteInbound_uncompleteInbound_person_openApplications = (
  deserialized: UncompleteInbound_uncompleteInbound_person_openApplications
): UncompleteInbound_uncompleteInbound_person_openApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeUncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations = (
  serialized: UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminationsOrig
): UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeUncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations = (
  deserialized: UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations
): UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface UncompleteInbound_uncompleteInbound_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  middleName: string | null
  lastName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  openApplications: UncompleteInbound_uncompleteInbound_person_openApplications[]
  mostRecentEligibilityDeterminations: UncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations[]
}
export const deserializeUncompleteInbound_uncompleteInbound_person = (
  serialized: UncompleteInbound_uncompleteInbound_personOrig
): UncompleteInbound_uncompleteInbound_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  openApplications: serialized.openApplications.map(
    deserializeUncompleteInbound_uncompleteInbound_person_openApplications
  ),
  mostRecentEligibilityDeterminations: serialized.mostRecentEligibilityDeterminations.map(
    deserializeUncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations
  ),
})
export const serializeUncompleteInbound_uncompleteInbound_person = (
  deserialized: UncompleteInbound_uncompleteInbound_person
): UncompleteInbound_uncompleteInbound_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  openApplications: deserialized.openApplications.map(
    serializeUncompleteInbound_uncompleteInbound_person_openApplications
  ),
  mostRecentEligibilityDeterminations: deserialized.mostRecentEligibilityDeterminations.map(
    serializeUncompleteInbound_uncompleteInbound_person_mostRecentEligibilityDeterminations
  ),
})
export interface UncompleteInbound_uncompleteInbound_personFormData {
  __typename: 'InboundPersonFormData'
  firstName: string | null
  lastName: string | null
  dob: Date | null
  phoneNumber: string | null
}
export const deserializeUncompleteInbound_uncompleteInbound_personFormData = (
  serialized: UncompleteInbound_uncompleteInbound_personFormDataOrig
): UncompleteInbound_uncompleteInbound_personFormData => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
})
export const serializeUncompleteInbound_uncompleteInbound_personFormData = (
  deserialized: UncompleteInbound_uncompleteInbound_personFormData
): UncompleteInbound_uncompleteInbound_personFormDataOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
})
export interface UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck {
  __typename: 'NjmmisCheck'
  id: string
  status: NjmmisCheckStatus
  medicaidId: string | null
  eligibleServices: string[] | null
}
export const deserializeUncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck = (
  serialized: UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheckOrig
): UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck => ({
  ...serialized,
})
export const serializeUncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck = (
  deserialized: UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck
): UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheckOrig => ({
  ...deserialized,
})
export interface UncompleteInbound_uncompleteInbound_account {
  __typename: 'Account'
  id: string
  department: string
  insuranceType: string
}
export const deserializeUncompleteInbound_uncompleteInbound_account = (
  serialized: UncompleteInbound_uncompleteInbound_accountOrig
): UncompleteInbound_uncompleteInbound_account => ({...serialized})
export const serializeUncompleteInbound_uncompleteInbound_account = (
  deserialized: UncompleteInbound_uncompleteInbound_account
): UncompleteInbound_uncompleteInbound_accountOrig => ({...deserialized})
export interface UncompleteInbound_uncompleteInbound {
  __typename: 'Inbound'
  id: string
  reason: string
  dateOfService: Date | null
  serviceType: ServiceType | null
  createdAt: Date
  lastIntakeWebformReceivedAt: Date | null
  inboundType: InboundType
  insuranceOnDateOfService: InboundInsuranceOnDateOfService | null
  startedBy: UncompleteInbound_uncompleteInbound_startedBy | null
  startedAt: Date | null
  completedBy: UncompleteInbound_uncompleteInbound_completedBy | null
  completedAt: Date | null
  person: UncompleteInbound_uncompleteInbound_person | null
  personFormData: UncompleteInbound_uncompleteInbound_personFormData | null
  mostRecentNjmmisCheck: UncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck | null
  account: UncompleteInbound_uncompleteInbound_account | null
}
export const deserializeUncompleteInbound_uncompleteInbound = (
  serialized: UncompleteInbound_uncompleteInboundOrig
): UncompleteInbound_uncompleteInbound => ({
  ...serialized,
  dateOfService:
    serialized.dateOfService != null
      ? parseDate(serialized.dateOfService)
      : serialized.dateOfService,
  createdAt: parseDate(serialized.createdAt),
  lastIntakeWebformReceivedAt:
    serialized.lastIntakeWebformReceivedAt != null
      ? parseDate(serialized.lastIntakeWebformReceivedAt)
      : serialized.lastIntakeWebformReceivedAt,
  startedBy:
    serialized.startedBy != null
      ? deserializeUncompleteInbound_uncompleteInbound_startedBy(
          serialized.startedBy
        )
      : serialized.startedBy,
  startedAt:
    serialized.startedAt != null
      ? parseDate(serialized.startedAt)
      : serialized.startedAt,
  completedBy:
    serialized.completedBy != null
      ? deserializeUncompleteInbound_uncompleteInbound_completedBy(
          serialized.completedBy
        )
      : serialized.completedBy,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
  person:
    serialized.person != null
      ? deserializeUncompleteInbound_uncompleteInbound_person(serialized.person)
      : serialized.person,
  personFormData:
    serialized.personFormData != null
      ? deserializeUncompleteInbound_uncompleteInbound_personFormData(
          serialized.personFormData
        )
      : serialized.personFormData,
  mostRecentNjmmisCheck:
    serialized.mostRecentNjmmisCheck != null
      ? deserializeUncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck(
          serialized.mostRecentNjmmisCheck
        )
      : serialized.mostRecentNjmmisCheck,
  account:
    serialized.account != null
      ? deserializeUncompleteInbound_uncompleteInbound_account(
          serialized.account
        )
      : serialized.account,
})
export const serializeUncompleteInbound_uncompleteInbound = (
  deserialized: UncompleteInbound_uncompleteInbound
): UncompleteInbound_uncompleteInboundOrig => ({
  ...deserialized,
  dateOfService:
    deserialized.dateOfService != null
      ? formatISODate(deserialized.dateOfService)
      : deserialized.dateOfService,
  createdAt: formatISO(deserialized.createdAt),
  lastIntakeWebformReceivedAt:
    deserialized.lastIntakeWebformReceivedAt != null
      ? formatISO(deserialized.lastIntakeWebformReceivedAt)
      : deserialized.lastIntakeWebformReceivedAt,
  startedBy:
    deserialized.startedBy != null
      ? serializeUncompleteInbound_uncompleteInbound_startedBy(
          deserialized.startedBy
        )
      : deserialized.startedBy,
  startedAt:
    deserialized.startedAt != null
      ? formatISO(deserialized.startedAt)
      : deserialized.startedAt,
  completedBy:
    deserialized.completedBy != null
      ? serializeUncompleteInbound_uncompleteInbound_completedBy(
          deserialized.completedBy
        )
      : deserialized.completedBy,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
  person:
    deserialized.person != null
      ? serializeUncompleteInbound_uncompleteInbound_person(deserialized.person)
      : deserialized.person,
  personFormData:
    deserialized.personFormData != null
      ? serializeUncompleteInbound_uncompleteInbound_personFormData(
          deserialized.personFormData
        )
      : deserialized.personFormData,
  mostRecentNjmmisCheck:
    deserialized.mostRecentNjmmisCheck != null
      ? serializeUncompleteInbound_uncompleteInbound_mostRecentNjmmisCheck(
          deserialized.mostRecentNjmmisCheck
        )
      : deserialized.mostRecentNjmmisCheck,
  account:
    deserialized.account != null
      ? serializeUncompleteInbound_uncompleteInbound_account(
          deserialized.account
        )
      : deserialized.account,
})
export interface UncompleteInbound {
  /**
   * Uncomplete inbound
   */
  uncompleteInbound: UncompleteInbound_uncompleteInbound
}
export const deserializeUncompleteInbound = (
  serialized: UncompleteInboundOrig
): UncompleteInbound => ({
  ...serialized,
  uncompleteInbound: deserializeUncompleteInbound_uncompleteInbound(
    serialized.uncompleteInbound
  ),
})
export const serializeUncompleteInbound = (
  deserialized: UncompleteInbound
): UncompleteInboundOrig => ({
  ...deserialized,
  uncompleteInbound: serializeUncompleteInbound_uncompleteInbound(
    deserialized.uncompleteInbound
  ),
})
export interface UncompleteInboundVariables {
  id: string
}
export const deserializeUncompleteInboundVariables = (
  serialized: UncompleteInboundVariablesOrig
): UncompleteInboundVariables => ({...serialized})
export const serializeUncompleteInboundVariables = (
  deserialized: UncompleteInboundVariables
): UncompleteInboundVariablesOrig => ({...deserialized})
